import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ToggleTabsMenuComponent } from '../../../../shared/components/toggle-tabs-menu/toggle-tabs-menu.component';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { ICustomer } from '../../core/interfaces/ICustomer';
import { CustomersService } from '../../core/services/CustomersService';
import { ActionsHistoryTableComponent } from '../../tables/actions-history-table/actions-history-table.component';
import { CardsTableComponent } from '../../tables/cards-table/cards-table.component';
import { LogsTableComponent } from '../../tables/logs-table/logs-table.component';
import { NewsletterTableComponent } from '../../tables/newsletter-table/newsletter-table.component';
import {
  TransactionPositionsTableComponent
} from '../../tables/transaction-positions-table/transaction-positions-table.component';
import {
  EditCustomerDetailsFormComponent
} from '../../forms/edit-customer-details-form/edit-customer-details-form.component';

@Component({
  selector: 'app-customer-details-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    ToggleTabsMenuComponent,
    LoaderComponent,
    ActionsHistoryTableComponent,
    CardsTableComponent,
    LogsTableComponent,
    NewsletterTableComponent,
    TransactionPositionsTableComponent,
    EditCustomerDetailsFormComponent,
  ],
  templateUrl: './customer-details-modal.component.html',
  styleUrl: './customer-details-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerDetailsModalComponent extends BaseModalComponent<{ customerId: number; }> {

  public customer: ICustomer;
  public selectedToggleTabsMenuOptionsIndex = 0;
  public readonly isLoading = signal(false);
  public readonly toggleTabsMenuOptions = [
    'Overview'.trans('customers/modals/customer-details/tabs/overview/tab.Title'),
    'Action'.trans('customers/modals/customer-details/tabs/action/tab.Title'),
    'Cards'.trans('customers/modals/customer-details/tabs/cards/tab.Title'),
    'Transaction positions'.trans('customers/modals/customer-details/tabs/transation-positions/tab.Title'),
    'Logs'.trans('customers/modals/customer-details/tabs/logs/tab.Title'),
    'Newsletter'.trans('customers/modals/customer-details/tabs/newsletter/tab.Title'),
  ];

  private readonly _customersService = inject(CustomersService);

  public override open(val?: { customerId: number; }): void {
    const customerId = val?.customerId;

    if (customerId == null) {
      this.notificationService.pushError(
        'Fehler'.trans('notifications/error.Title'),
        'Customer not found.'.trans('get-customer-by-id/notifications/CustomerNotFound.Message')
      );
      return;
    }

    this.customer = null;
    this.selectedToggleTabsMenuOptionsIndex = 0;
    this.isLoading.set(true);
    super.open({ customerId });
    this.cdr.detectChanges();

    this._customersService.getCustomerById(customerId, true)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: res => this.customer = res.data,
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`get-customer-by-id/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
